import React from 'react';

const OrderFilters = ({ 
  showGunOrders, 
  showPhotoOrders, 
  onToggleGunOrders, 
  onTogglePhotoOrders,
  gunOrderCount,
  photoOrderCount 
}) => {
  return (
    <div className="order-filter-buttons">
      <button
        className={`btn ${showGunOrders ? "btn-active" : ""}`}
        onClick={onToggleGunOrders}
      >
        {showGunOrders ? "Hide" : "Show"} Gun Orders
        <span className="badge">{gunOrderCount}</span>
      </button>

      <button
        className={`btn ${showPhotoOrders ? "btn-active" : ""}`}
        onClick={onTogglePhotoOrders}
      >
        {showPhotoOrders ? "Hide" : "Show"} Media Orders
        <span className="badge">{photoOrderCount}</span>
      </button>
    </div>
  );
};

export default OrderFilters;